import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logo from '../components/Logo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    if (!sessionId) {
      navigate('/admin', { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => navigate('/admin', { state: { user: r.data }, replace: true }))
      .catch((err) =>
        navigate('/admin', {
          state: { authError: err.response?.data?.detail || 'Sign-in failed. Please try again.' },
          replace: true,
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bluedark grain relative" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-5">
        <Logo dark size={52} />
        <span className="w-8 h-8 rounded-full border-[3px] border-white/20 border-t-brand-orange animate-spin" />
        <p className="text-sm font-semibold text-white/70">Signing you in securely…</p>
      </div>
    </div>
  );
}
